import 'frontend-login/assets/tailwind.css';
import '@mylighthouse/prism-ember/global-styles.css';
import 'frontend-utils/app/styles/frontend-utils/index.css';
import 'password-form/app/styles/password-form/index.css';
import 'frontend-login/assets/app.css';
import 'core-js/stable';
/**
 * Required for compiling generators/async functions to ES5. Can be removed once we drop old browser support.
 * https://babeljs.io/docs/babel-polyfill
 */
import 'regenerator-runtime/runtime';
import 'decorator-transforms/globals';

import Application from '@ember/application';
import setupInspector from '@embroider/legacy-inspector-support/ember-source-4.12';
import loadInitializers from 'ember-load-initializers';
import Resolver from 'ember-resolver';
import ENV from 'frontend-login/config/environment';
import { initializeErrorTracking } from 'frontend-utils/services/error-tracking';

initializeErrorTracking(ENV['@sentry/ember'].sentry);

export default class App extends Application {
  inspector = setupInspector(this);
  modulePrefix = ENV.modulePrefix;
  podModulePrefix = ENV.podModulePrefix;
  Resolver = Resolver;
}

loadInitializers(App, ENV.modulePrefix);
